// =================================================================
// 6. JWT INTERCEPTOR
// Path: src/app/core/interceptors/jwt.interceptor.ts
// =================================================================
// This interceptor will automatically attach the JWT to API requests only.

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();
    
    // Only add Bearer token to requests going to our API
    const isApiRequest = request.url.startsWith(environment.apiUrl);
    
    if (token && isApiRequest) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.success === false && event.body.message === 'Unauthorized' && isApiRequest) {
            // Only redirect to session expired if a token was present in the API request
            if (token) {
              this.authService.redirectUrl = this.router.url;
              this.router.navigate(['/session-expired']);
            } else {
              // If no token was present, just go to login
              this.router.navigate(['/auth/login']);
            }
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && isApiRequest) {
          // Only redirect to session expired if a token was present in the API request
          if (token) {
            this.authService.redirectUrl = this.router.url;
            this.router.navigate(['/session-expired']);
          } else {
            // If no token was present, just go to login
            this.router.navigate(['/auth/login']);
          }
        }
        return throwError(() => error);
      })
    );
  }
}

